export default __webpack_public_path__ + "static/media/aplikacija.239a9e65.jpg";